import { FC, useContext } from 'react'

import { Button, ButtonProps, Text } from '@hhgtech/hhg-components/mantine'
import { ChevronRight } from '@hhgtech/icons/arrow'

import useStyles from './index.styles'
import { FeatureCardContext } from '../../context'

type ViewAllProps = {
  href?: string
  children: string
} & ButtonProps

const FeatureCardViewAll: FC<ViewAllProps> = ({
  children,
  href,
  styles,
  classNames,
  className,
  ...rest
}) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'FeatureCard__VerticalCenterLayout',
    styles,
    classNames,
  })
  const { color, url } = useContext(FeatureCardContext)
  const finalUrl = href || url
  if (!finalUrl) return null
  const commonProps = { href: finalUrl }
  return (
    <Button
      className={cx(classes.root, className)}
      component={'a'}
      variant="secondary"
      size="lg"
      rightIcon={<ChevronRight color="currentColor" size={20} />}
      color={color === 'gray' ? 'yellow' : color || 'green'}
      withColorHover
      {...commonProps}
      {...rest}
    >
      <Text size="p1" color="inherit" weight="semiBold">
        {children}
      </Text>
    </Button>
  )
}

FeatureCardViewAll.displayName = 'FeatureCardViewAll'

export default FeatureCardViewAll
